// src/navigationSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  changed: false,
};

const savePopupSlice = createSlice({
  name: "savePopup",
  initialState,
  reducers: {
    updateSavePopupToTrue: (state, action) => {
      return { changed: true };
    },
    resetSavePopup: (state, action) => {
      return initialState; // Reset to initial stat
    },
  },
});

export const { updateSavePopupToTrue, resetSavePopup } = savePopupSlice.actions;

export default savePopupSlice.reducer;
